import Vue from 'vue'
import Router from 'vue-router'
import axios from "./axios";
import auth from '@/helper/auth'

Vue.use(Router)

const ifAuthenticated = (to, from, next) => {
  if (localStorage.getItem("user_cnhu") && localStorage.getItem("user_cnhu") !== null) {
    next();
    return;
  }
  next('/login');
}
const guest = (to, form, next) => {
  if (localStorage.getItem("user_cnhu") && localStorage.getItem("user_cnhu") !== null) {
    if (to.name == 'page-login' || to.name == 'callback'){
      next('/')
    }
  }else {
    next();
    return;
  }
}

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior () {
        return { x: 0, y: 0 }
    },
    routes: [

        {
            path: '',
            component: () => import('./layouts/main/Main.vue'),
            children: [
              {
                path: '/',
                name: 'home',
                component: () => import('./views/Dashboard.vue'),
                beforeEnter: ifAuthenticated,
              },
              {
                path: '/payments',
                name: 'payments',
                component: () => import('./views/Payments/index.vue'),
                beforeEnter: ifAuthenticated,
              },
              {
                path: '/payments/validate',
                name: 'validate',
                component: () => import('./views/Payments/validate.vue'),
                beforeEnter: ifAuthenticated,
              },
              {
                path: '/payments/verify',
                name: 'verify',
                component: () => import('./views/Payments/verify.vue'),
                beforeEnter: ifAuthenticated,
              },
              {
                path: '/users',
                name: 'users',
                component: () => import('./views/Users/index.vue'),
                beforeEnter: ifAuthenticated,
              },
              {
                path: '/users/detail/:id/grant',
                name: 'grant',
                component: () => import('./views/Users/grant.vue'),
                beforeEnter: ifAuthenticated,
              },
              {
                path: '/profile',
                name: 'profile',
                component: () => import('./views/Users/profile.vue'),
                beforeEnter: ifAuthenticated,
              },
              {
                path: '/users/praticiens',
                name: 'praticiens',
                component: () => import('./views/Praticiens/index.vue'),
                beforeEnter: ifAuthenticated,
              },
              {
                path: '/specialities',
                name: 'specialities',
                component: () => import('./views/Specialities/index.vue'),
                beforeEnter: ifAuthenticated,
              },
              {
                path: '/logs',
                name: 'logs',
                component: () => import('./views/Logs/index.vue'),
                beforeEnter: ifAuthenticated,
              },
              {
                path: '/statistics/to-validate',
                name: 'tovalidate',
                component: () => import('./views/Statistics/tovalidate.vue'),
                beforeEnter: ifAuthenticated,
              },
              {
                path: '/statistics/to-canceled',
                name: 'tocanceled',
                component: () => import('./views/Statistics/canceled.vue'),
                beforeEnter: ifAuthenticated,
              },
              {
                path: '/statistics/is-validate',
                name: 'isvalidate',
                component: () => import('./views/Statistics/validate.vue'),
                beforeEnter: ifAuthenticated,
              },
              {
                path: '/statistics/is-expired',
                name: 'isexpired',
                component: () => import('./views/Statistics/expired.vue'),
                beforeEnter: ifAuthenticated,
              },
              {
                path: '/statistics/with-specialities',
                name: 'withspecialities',
                component: () => import('./views/Chiffre/specialities.vue'),
                beforeEnter: ifAuthenticated,
              },
              {
                path: '/statistics/with-operator',
                name: 'withoperator',
                component: () => import('./views/Chiffre/operator.vue'),
                beforeEnter: ifAuthenticated,
              },
            ],
        },
        {
            path: '',
            component: () => import('@/layouts/full-page/FullPage.vue'),
            children: [
              {
                path: '/loginad',
                name: 'custom',
                component: () => import('@/views/pages/Ad.vue'),
                beforeEnter: guest,
              },
              {
                path: '/login',
                name: 'page-login',
                component: () => import('@/views/pages/Login.vue'),
                beforeEnter: guest,
              },
              {
                path: '/callback',
                name: 'callback',
                component: () => import('@/views/pages/Callback.vue'),
                beforeEnter: guest,
              },
              {
                path: '/error-404',
                name: 'page-error-404',
                component: () => import('@/views/pages/Error404.vue')
              },
            ]
        },
        {
            path: '*',
            redirect: '/pages/error-404'
        }
    ],
})

router.afterEach(() => {
  if (auth.getSession() !== null){
      axios.defaults.headers.common['Authorization'] = `Bearer ${auth.getSession()}`;
  }
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
      appLoading.style.display = "none";
  }
})

export default router
